<script setup>
import { ref, computed, watch } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useGroupsAttrsStore } from '@/stores/groups-attrs'
import { useCarUsersGroupsStore } from '@/stores/car-users-groups'
import Modal from '@/components/UTAModal.vue'
import checkArrayIncludes from '@/helpers/checkArrayIncludes'

function checkSelected(mode) {

    let result = false
    let attrs = []

    carUsersGroups.value.array.map( link => {
        if(link.ugroup == props.group.uuid) {
            attrs = link.attr.array
        }
    })

    switch(mode) {

        case 'geodata':         result = attrs.includes('GEODATA') ? true : false
            break

        case 'remote-constrol': result = attrs.includes('REMOTE_CONTROL') ? true : false
            break

        case 'diagnostic':      result = attrs.includes('DIAGNOSTIC') ? true : false
            break

        case 'developer':       result = checkArrayIncludes(attrs, ['COMMAND', 'FIRMWARE', 'LOGS_CAR', 'PARAM']) ? true : false
            break
        }

    return result
}

function submitForm(event) {

    const fields = event.target.getElementsByTagName('input')

    let data = {
        attr: { array: [] },
        car: props.uuid,
        ugroup: props.group.uuid
    }

    for(let field of fields) {
        if(field.type == 'checkbox' && field.checked) {
            if(field.name == 'geodata')         data.attr.array.push(...attrsNavi.value)
            if(field.name == 'remote-control')  data.attr.array.push(...attrsRemote.value)
            if(field.name == 'diagnostic')      data.attr.array.push(...attrsDiagnostic.value)
            if(field.name == 'developer')       data.attr.array.push(...attrsDeveloper.value)
        }
    }

    carUsersGroupsStore.updateCarUsersGroup(data)
}

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }, 
    group: {
        type: Object,
        required: true
    },
    outerIndex: {
        type: Number,
        required: true
    }
})

const translaterStore       = useTranslaterStore()
const groupsAttrsStore      = useGroupsAttrsStore()
const carUsersGroupsStore   = useCarUsersGroupsStore()

const getTranslate                  = computed(() => translaterStore.getTranslate)
const attrsNavi                     = computed(() => groupsAttrsStore.navi)
const attrsRemote                   = computed(() => groupsAttrsStore.remote)
const attrsDiagnostic               = computed(() => groupsAttrsStore.diagnostic)
const attrsDeveloper                = computed(() => groupsAttrsStore.developer)
const carUsersGroups                = computed(() => carUsersGroupsStore.carUsersGroups)
const carUsersGroupsUpdateMsg       = computed(() => carUsersGroupsStore.carUsersGroupsUpdateMsg)
const carUsersGroupsDeleteProcess   = computed(() => carUsersGroupsStore.carUsersGroupsDeleteProcess)

const showDeleteCarUserGroup = ref(false)
const showAttrs = ref(false)

watch(carUsersGroupsUpdateMsg, msg => {
    if('success' in msg && msg.success) {
        showAttrs.value = false
    }
})
</script>

<template>
    <div class="col-10">
        <div class="row">
            <div class="col-12 col-lg-5 uta-car-users-group__car-vin">
                <span class="d-inline d-lg-none uta-car-users-group__car-mobile-title">{{ getTranslate.CAR_RIGHTS_USERS_GROUPS_NAME }}: </span>
                <router-link :to="'/users-groups/' + props.group.uuid" class="uta-list__item-link uta-car-users-group__link">
                    {{ props.group.name }}
                </router-link>
            </div>
            <div class="col-12 col-lg-7 uta-car-users-group__car-model">
                <span class="d-inline d-lg-none uta-car-users-group__car-mobile-title">{{ getTranslate.CAR_RIGHTS_USERS_GROUPS_DESCR }}: </span>
                {{ props.group.descr || '-' }}
            </div>
        </div>
    </div>
    <div class="col-2 text-end">
        <span 
            class="p-2 material-icons uta-list__item-icon"
            :class="'accordion_' + props.group.uuid + props.outerIndex"
            @click="showAttrs = !showAttrs"
        >
            settings
        </span>
        <span
            class="p-2 material-icons uta-list__item-icon"
            :title="getTranslate.BTN_DELETE"
            @click="
                showDeleteCarUserGroup = true, 
                deleteCarUsersGroupsUuid = props.group.uuid
            "
        >
            delete
        </span>
    </div>

    <div class="col-12 pt-3 uta-car-users-group__attrs" v-if="showAttrs">

        <form action="" @submit.prevent="submitForm($event)">

            <!-- Навигационная информация -->
            <div class="form-check">
                <input 
                    type="checkbox" 
                    name="navi"
                    class="form-check-input uta-car-users-group__attrs-attr" 
                    :checked="checkSelected('geodata')"
                    :id="'uta-car-users-group__navi-' + group.uuid"
                > 
                <label 
                    class="form-check-label" 
                    :for="'uta-car-users-group__navi-' + group.uuid"
                >
                    {{ getTranslate.ATTR_GEODATA }}
                </label>
            </div>

            <!-- Удаленное управление -->
            <div class="form-check">
                <input 
                    type="checkbox" 
                    name="remote"
                    class="form-check-input uta-users-group-cars__attrs-attr" 
                    :checked="checkSelected('remote-constrol')"
                    :id="'users-group-cars-attr_remote-' + group.uuid"
                > 
                <label 
                    class="form-check-label" 
                    :for="'users-group-cars-attr_remote-' + group.uuid"
                >
                    {{ getTranslate.ATTR_REMOTE_CONTROL }}
                </label>
            </div>

            <!-- Диагностика -->
            <div class="form-check">
                <input 
                    type="checkbox" 
                    name="diagnostic"
                    class="form-check-input uta-users-group-cars__attrs-attr" 
                    :checked="checkSelected('diagnostic')"
                    :id="'users-group-cars-attr_diagnostic-' + group.uuid"
                > 
                <label 
                    class="form-check-label" 
                    :for="'users-group-cars-attr_diagnostic-' + group.uuid"
                >
                    {{ getTranslate.ATTR_DIAGNOSTIC }}
                </label>
            </div>

            <!-- Режим разработчика -->
            <div class="form-check">
                <input 
                    type="checkbox" 
                    name="developer"
                    class="form-check-input uta-users-group-cars__attrs-attr"
                    :checked="checkSelected('developer')" 
                    :id="'users-group-cars-attr_developer-' + group.uuid"
                > 
                <label 
                    class="form-check-label" 
                    :for="'users-group-cars-attr_developer-' + group.uuid"
                >
                    {{ getTranslate.ATTRS_DEVELOPER }}
                </label>
            </div>

            <input type="hidden" name="ugroup" :value="group.uuid">
            <input type="hidden" name="car" :value="props.uuid">

            <button type="submit" class="uta-btn uta-btn--main mt-3">{{ getTranslate.BTN_UPDATE }}</button>

        </form>

    </div>

    <transition name="bounce">
        <Modal 
            v-if="showDeleteCarUserGroup"
            :header="getTranslate.CAR_RIGHTS_USERS_GROUPS_DELETE"
            size="md"
            @closeModal="showDeleteCarUserGroup = false"
        >
            <template v-slot:body>
                <form action="" @submit.prevent="carUsersGroupsStore.deleteCarUsersGroups({ car: props.uuid, ugroup: group.uuid })">
                    {{ getTranslate.CAR_RIGHTS_USERS_GROUPS_DELETE_DESCR }}
                    <div class="mt-5 uta-btns">
                        <button type="button" class="uta-btn" @click="showDeleteCarUserGroup = false">{{ getTranslate.BTN_CANCEL }}</button>
                        <button type="submit" class="uta-btn uta-btn--main" :disabled="carUsersGroupsDeleteProcess">{{ getTranslate.BTN_DELETE }}</button>
                    </div>
                </form>
            </template>
        </Modal>
    </transition>

</template>
